import React, { useEffect, useMemo } from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import { Search, MessageCircleMore, Hammer, Repeat2 } from 'lucide-react';
import Menu from '../sections/Menu';
import Footer from '../sections/Footer';
import PageMeta from '../seo/PageMeta';
import { buildAboutPageStructuredData } from '../seo/structuredData';

// Import images for the team section
import kwImage from '../images/KW.jpg';
import dpImage from '../images/DP.jpeg';
import ibImage from '../images/IB.jpeg';

function ONas() {
  const aboutStructuredData = useMemo(
    () => [buildAboutPageStructuredData("/o-nas")],
    []
  );

  useEffect(() => {
    // Obsługa scroll do sekcji po załadowaniu strony
    if (window.location.hash) {
      setTimeout(() => {
        const id = window.location.hash.substring(1);
        const element = document.getElementById(id);
        if (element) {
          const offset = 100;
          const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({ top: elementPosition - offset, behavior: 'smooth' });
        }
      }, 100);
    }
  }, []);

  return (
    <>
      <PageMeta path="/o-nas" structuredData={aboutStructuredData} />
      <Menu />
      <Container className="py-5 mt-5">
        {/* Sekcja: Misja i Wartości */}
        <section id="misja-wartosci" className="mb-5 pb-5">
          <h2 className="mb-5" style={{ fontSize: '2.5rem', fontWeight: '700', color: '#1f2937' }}>
            Misja i Wartości
          </h2>

          <h3 className="mb-5 text-center" style={{ fontSize: '1.8rem', color: '#2d6ff4' }}>Misja</h3>
          <blockquote style={{
            backgroundColor: '#f8f9fa',
            borderLeft: '4px solid #2d6ff4',
            borderRadius: '8px',
            padding: '20px',
            margin: '0 0 100px 0',
            fontStyle: 'italic',
            fontSize: '1.2rem',
            lineHeight: '1.8',
            color: '#4b5563'
          }}>
            "Chcemy, żeby rozliczanie czasu pracy było proste i szybkie.<br />
            Automatyzujemy to, co powtarzalne, żeby firmy mogły skupić się na pracy, a nie na papierach."
          </blockquote>

          <h3 className="mb-5 text-center" style={{ fontSize: '1.8rem', color: '#2d6ff4' }}>Wartości</h3>
          <Row>
            <Col md={6} lg={3} className="mb-4">
              <div style={{
                backgroundColor: '#f8f9fa',
                padding: '30px',
                borderRadius: '10px',
                height: '100%',
                textAlign: 'center',
                border: '2px solid #e5e7eb',
                transition: 'transform 0.2s'
              }}>
                <div style={{ marginBottom: '15px' }}>
                  <Search size={48} color="#2d6ff4" />
                </div>
                <h4 style={{ fontSize: '1.3rem', fontWeight: '600', color: '#1f2937', marginBottom: '10px' }}>
                  Zaczynamy od problemu
                </h4>
                <p style={{ fontSize: '1rem', color: '#6b7280', margin: 0 }}>
                  nie od funkcji
                </p>
              </div>
            </Col>
            <Col md={6} lg={3} className="mb-4">
              <div style={{
                backgroundColor: '#f8f9fa',
                padding: '30px',
                borderRadius: '10px',
                height: '100%',
                textAlign: 'center',
                border: '2px solid #e5e7eb',
                transition: 'transform 0.2s'
              }}>
                <div style={{ marginBottom: '15px' }}>
                  <MessageCircleMore size={48} color="#2d6ff4" />
                </div>
                <h4 style={{ fontSize: '1.3rem', fontWeight: '600', color: '#1f2937', marginBottom: '10px' }}>
                  Słuchamy użytkowników
                </h4>
                <p style={{ fontSize: '1rem', color: '#6b7280', margin: 0 }}>
                  funkcja ma sens tylko wtedy, gdy ktoś jej potrzebuje
                </p>
              </div>
            </Col>
            <Col md={6} lg={3} className="mb-4">
              <div style={{
                backgroundColor: '#f8f9fa',
                padding: '30px',
                borderRadius: '10px',
                height: '100%',
                textAlign: 'center',
                border: '2px solid #e5e7eb',
                transition: 'transform 0.2s'
              }}>
                <div style={{ marginBottom: '15px' }}>
                  <Hammer size={48} color="#2d6ff4" />
                </div>
                <h4 style={{ fontSize: '1.3rem', fontWeight: '600', color: '#1f2937', marginBottom: '10px' }}>
                  Budujemy prosto
                </h4>
                <p style={{ fontSize: '1rem', color: '#6b7280', margin: 0 }}>
                  ma działać, nie błyszczeć
                </p>
              </div>
            </Col>
            <Col md={6} lg={3} className="mb-4">
              <div style={{
                backgroundColor: '#f8f9fa',
                padding: '30px',
                borderRadius: '10px',
                height: '100%',
                textAlign: 'center',
                border: '2px solid #e5e7eb',
                transition: 'transform 0.2s'
              }}>
                <div style={{ marginBottom: '15px' }}>
                  <Repeat2 size={48} color="#2d6ff4" />
                </div>
                <h4 style={{ fontSize: '1.3rem', fontWeight: '600', color: '#1f2937', marginBottom: '10px' }}>
                  Ulepszamy na bieżąco
                </h4>
                <p style={{ fontSize: '1rem', color: '#6b7280', margin: 0 }}>
                  skupiamy się na realnych usprawnieniach
                </p>
              </div>
            </Col>
          </Row>
        </section>

        {/* Sekcja: Historia */}
        <section id="historia" className="mb-5 pb-5" style={{ borderTop: '2px solid #e5e7eb', paddingTop: '3rem' }}>
          <h2 className="mb-5" style={{ fontSize: '2.5rem', fontWeight: '700', color: '#1f2937', textAlign: 'center' }}>
            Nasza Historia
          </h2>

          <div className="history-wrapper">
            {/* Centralna linia czasu */}
            <div className="history-line"></div>

            {/* Od wspólnej ławki do wspólnej spółki */}
            <Row className="mb-5 position-relative history-row">
              <Col md={6} className="d-flex justify-content-end align-items-center history-image-col">
                <Image
                  src={require('../images/liceum.jpg')}
                  alt="Od wspólnej ławki do wspólnej spółki"
                  fluid
                  rounded
                  className="history-image"
                />
              </Col>
              <Col md={6} className="history-text-col">
                <div className="history-dot"></div>
                <div className="history-text">
                  <h3 className="mb-3" style={{ fontSize: '1.8rem', fontWeight: '600', color: '#2d6ff4', textAlign: 'left' }}>
                    Od wspólnej ławki do wspólnej spółki
                  </h3>
                  <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#4b5563', textAlign: 'left' }}>
                    Znamy się jeszcze z czasów liceum. Siedzieliśmy w tej samej klasie, razem robiliśmy
                    pierwsze projekty i kombinowaliśmy, jak coś ulepszyć albo uprościć.
                    <br /><br />
                    To, że dziś tworzymy firmę razem, nie jest przypadkiem. Od początku nadawaliśmy na tych samych falach.
                  </p>
                </div>
              </Col>
            </Row>

            {/* Skąd pomysł */}
            <Row className="mb-5 position-relative history-row">
              <Col md={6} className="order-md-1 d-flex justify-content-end history-image-col">
                <div className="history-dot"></div>
                <div className="history-text">
                  <h3 className="mb-3" style={{ fontSize: '1.8rem', fontWeight: '600', color: '#2d6ff4', textAlign: 'left' }}>
                    Skąd pomysł?
                  </h3>
                  <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#4b5563', textAlign: 'left' }}>
                    Pomysł pojawił się dużo później podczas studiów i pierwszych doświadczeń zawodowych.
                    Zobaczyliśmy, jak wiele firm wciąż prowadzi ewidencję czasu pracy na papierze albo
                    w Excelu.
                    <br /><br />
                    Postanowiliśmy zrobić z tym porządek i stworzyć proste, intuicyjne narzędzie,
                    które po prostu działa.
                  </p>
                </div>
              </Col>
              <Col md={6} className="d-flex justify-content-start align-items-center order-md-2 history-text-col">
                <Image
                  src={require('../images/carpathian.JPG')}
                  alt="Skąd wzięły się eGodziny"
                  fluid
                  rounded
                  className="history-image"
                />
              </Col>
            </Row>

            {/* Od pomysłu do spółki */}
            <Row className="mb-5 position-relative history-row">
              <Col md={6} className="d-flex justify-content-end align-items-center history-image-col">
                <Image
                  src={require('../images/notariusz.jpg')}
                  alt="Od pomysłu do spółki"
                  fluid
                  rounded
                  className="history-image"
                />
              </Col>
              <Col md={6} className="history-text-col">
                <div className="history-dot"></div>
                <div className="history-text">
                  <h3 className="mb-3" style={{ fontSize: '1.8rem', fontWeight: '600', color: '#2d6ff4', textAlign: 'left' }}>
                    Początek eGodzin
                  </h3>
                  <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#4b5563', textAlign: 'left' }}>
                    Z pomocą przyszła Politechnika Gdańska i program dla młodych projektów technologicznych.
                    Zdobyliśmy pierwszy grant, stworzyliśmy prototyp i zaczęliśmy testy z pierwszymi firmami.
                    <br /><br />
                    W dniu, gdy podpisaliśmy akt notarialny i oficjalnie powołaliśmy spółkę, wiedzieliśmy,
                    że to dopiero początek.
                  </p>
                </div>
              </Col>
            </Row>
          </div>

          {/* eGodziny dziś */}
          <div style={{
            backgroundColor: '#f8f9fa',
            padding: '40px',
            borderRadius: '10px',
            border: '2px solid #e5e7eb',
            marginTop: '60px'
          }}>
            <h3 className="mb-4" style={{ fontSize: '1.8rem', fontWeight: '600', color: '#2d6ff4' }}>
              eGodziny dziś
            </h3>
            <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#4b5563', marginBottom: '0' }}>
              Zaczynaliśmy od bardzo prostego narzędzia do wpisywania godzin pracy.
              Dziś eGodziny to pełnoprawny system z aplikacją mobilną, GPS-em i wieloma sposobami
              rejestrowania czasu. Nadal jednak trzymamy się tej samej zasady – ma być prosto,
              przejrzyście i bez zbędnych komplikacji.
            </p>
          </div>
        </section>

        {/* Sekcja: Zespół */}
        <section id="zespol" style={{ borderTop: '2px solid #e5e7eb', paddingTop: '3rem' }}>
          <h2 className="mb-4" style={{ fontSize: '2.5rem', fontWeight: '700', color: '#1f2937' }}>
            Zespół Założycielski
          </h2>
          <p className="mb-5" style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#4b5563' }}>
            Tworzymy eGodziny. I sami z nich korzystamy.
          </p>
          <Row className="justify-content-center">
            <Col md={4} className="mb-4 text-center">
              <div style={{
                backgroundColor: '#f8f9fa',
                padding: '30px',
                borderRadius: '10px',
                height: '100%'
              }}>
                <Image
                  src={kwImage}
                  alt="Krzysztof Warda"
                  roundedCircle
                  style={{
                    width: '150px',
                    height: '150px',
                    objectFit: 'cover',
                    margin: '0 auto 20px',
                    display: 'block'
                  }}
                />
                <h4 style={{ fontSize: '1.5rem', fontWeight: '600', color: '#1f2937' }}>
                  Krzysztof Warda
                </h4>
                <p style={{ fontSize: '1rem', color: '#6b7280', marginBottom: '10px' }}>
                  Sprzedaż i Klienci
                </p>
                <p style={{ fontSize: '0.95rem', color: '#9ca3af' }}>
                  krzysztof.warda@egodziny.pl
                </p>
              </div>
            </Col>
            <Col md={4} className="mb-4 text-center">
              <div style={{
                backgroundColor: '#f8f9fa',
                padding: '30px',
                borderRadius: '10px',
                height: '100%'
              }}>
                <Image
                  src={dpImage}
                  alt="Dominik Pogorzelski"
                  roundedCircle
                  style={{
                    width: '150px',
                    height: '150px',
                    objectFit: 'cover',
                    margin: '0 auto 20px',
                    display: 'block'
                  }}
                />
                <h4 style={{ fontSize: '1.5rem', fontWeight: '600', color: '#1f2937' }}>
                  Dominik Pogorzelski
                </h4>
                <p style={{ fontSize: '1rem', color: '#6b7280', marginBottom: '10px' }}>
                  Rozwój i Operacje
                </p>
                <p style={{ fontSize: '0.95rem', color: '#9ca3af' }}>
                  dominik.pogorzelski@egodziny.pl
                </p>
              </div>
            </Col>
            <Col md={4} className="mb-4 text-center">
              <div style={{
                backgroundColor: '#f8f9fa',
                padding: '30px',
                borderRadius: '10px',
                height: '100%'
              }}>
                <Image
                  src={ibImage}
                  alt="Iwona Bendig"
                  roundedCircle
                  style={{
                    width: '150px',
                    height: '150px',
                    objectFit: 'cover',
                    margin: '0 auto 20px',
                    display: 'block'
                  }}
                />
                <h4 style={{ fontSize: '1.5rem', fontWeight: '600', color: '#1f2937' }}>
                  Iwona Bendig
                </h4>
                <p style={{ fontSize: '1rem', color: '#6b7280', marginBottom: '10px' }}>
                  Technologia
                </p>
                <p style={{ fontSize: '0.95rem', color: '#9ca3af' }}>
                  iwona.bendig@egodziny.pl
                </p>
              </div>
            </Col>
          </Row>
          <p className="text-center mt-4" style={{
            fontSize: '0.9rem',
            color: '#6b7280',
            fontStyle: 'italic'
          }}>
            *Zespół eGodziny oświadcza, że korzysta z eGodzin w ramach pracy nad eGodzinami <span style={{ fontStyle: 'normal' }}>🙃</span>
          </p>
        </section>
      </Container>
      <Footer />
    </>
  );
}

export default ONas;
